export default {
    stringToDateObject(dateString) {
        return new Date(dateString.replace(new RegExp('-', 'g'), '/'));
    }
};
